module.exports = __webpack_public_path__ + "img/82.19902f8.png";